module.exports = __webpack_public_path__ + "static/media/Автоваз-Dark.7417ce02.webp";